<template>
  <el-table-column
    prop="mailing_address"
    label="Levelezési cím"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      <span v-if="getAddresses(scope.row.company.addresses).length">
        <span :key="address.id" v-for="address in getAddresses(scope.row.company.addresses)">
          {{ address.postal_code }} {{ address.city }} {{ address.address }}
        </span>
      </span>
      <div v-else>
        <el-tag size="small" type="danger">Nincs levelezési cím</el-tag>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'mailing_address',
  methods: {
    getAddresses(addresses) {
      return addresses.filter(address => address.pivot.type === 'mailing');
    },
  },
};
</script>
